import './heroSection.scss';

import FivePlusImage from '../../images/5+.png';
import MobileNav from '../../components/MobileNav';
import HundredPlusImage from '../../images/100+.png';
import contractorImage from '../../images/hero-contractor.svg';
import { RequestQuote } from '../../components/request-quote/RequestQuote';
import useIsMobile from '../../utils/useMobile';

export const HeroSection = () => {
  const isMobile = useIsMobile();
  return (
    <div className={'hero'} id={'home'}>
      <div className={'hero__wrapper'}>
        <div className={'hero__wrapper__details'}>
          <div className={'hero__wrapper__details__left'}>
            {isMobile && <MobileNav />}

            <h4>Home</h4>
            <h1>Efficient and Dependable Home Maintenance Services</h1>
            <br />
            <br />
            <div className={'hero__wrapper__banner__right'}>
              <div
                style={{ width: 150, justifyItems: 'center' }}
                className="hero__wrapper__banner__right__row"
              >
                <h1>8+</h1>
                <div>
                  <p>Years Of Experience</p>
                </div>
              </div>
              <div
                style={{ width: 215, justifyItems: 'center' }}
                className="hero__wrapper__banner__right__row"
              >
                <h1>300+</h1>
                <div>
                  <p>Projects Completed</p>
                </div>
              </div>
            </div>
          </div>
          <div className={'hero__wrapper__details__right'}>
            <img width={650} alt={'contractor image'} src={contractorImage} />
          </div>
        </div>
        <div className={'hero__wrapper__banner'}>
          <div className={'hero__wrapper__banner__right hide-on-mobile'}></div>
        </div>
      </div>
    </div>
  );
};
